/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-11-01",
    versionChannel: "nightly",
    buildDate: "2023-11-01T00:24:01.956Z",
    commitHash: "432a63250b800ea39a742e6fc76cf4da8a81ecc1",
};
